<template>
	<div class="grid spe-v2-email-mapping-page">
		<Toast />
		<div class="col-12">
			<Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
		</div>

		<div class="col-12">
			<div class="content-wrapper">
				<div class="content-header">SPE Report Email Mapping</div>
				<div class="content-body">
					<div class="spe-v2-email-mapping-toolbar">
						<div style="width: 50%">
							<div class="spe-v2-email-mapping-title">Supplier Email Mapping</div>
							<div class="spe-v2-email-mapping-subtitle">
								Mapping alamat email To dan CC untuk supplier SPE yang belum punya akun supplier portal.
							</div>
						</div>
						<div class="flex align-items-center justify-content-end gap-3 flex-wrap" style="width: 50%">
						<AutoComplete
							v-model="selectedSearchSupplier"
							:suggestions="filteredSearchSupplierOptions"
							field="supplier_name"
							:dropdown="true"
							:forceSelection="true"
							:completeOnFocus="true"
							:loading="loadingSearchOptions"
							placeholder="Search supplier name"
							class="spe-v2-email-mapping-search mr-4"
							panelClass="spe-v2-email-mapping-ac-panel"
							appendTo="body"
							:baseZIndex="EMAIL_MAPPING_OVERLAY_Z_INDEX"
							:autoZIndex="true"
							@complete="searchSupplierLov"
							@dropdown-click="loadSearchSupplierLov"
							@item-select="onSearchSupplierSelected"
							@clear="clearSearchSupplier"
						>
								<template #item="slotProps">
									<div class="spe-v2-email-mapping-search-option">
										<div class="font-medium">{{ slotProps.item.supplier_name }}</div>
										<div class="text-500 text-sm">{{ slotProps.item.vendor_id }}</div>
									</div>
								</template>
							</AutoComplete>
							<Button label="Add" icon="pi pi-plus" class="p-button-success" :disabled="!isPurchasingUser" @click="openAddDialog" />
						</div>
					</div>

					<DataTable
						:value="mappingRows"
						:lazy="true"
						:paginator="true"
						:rows="rowsPerPage"
						:totalRecords="totalRecords"
						:first="firstRow"
						:scrollable="true" 
						:loading="loadingMappings"
						dataKey="row_key"
						responsiveLayout="scroll"
						stripedRows
						class="spe-v2-email-mapping-table"
						@page="onPage"
					>
						<template #empty>
							<div class="py-4 text-center text-500">Belum ada mapping supplier untuk company ini.</div>
						</template>

						<Column header="Supplier" field="supplier_name" style="min-width: 25%;">
							<template #body="{ data }">
								<div class="font-medium">{{ data.supplier_name || '-' }}</div>
							</template>
						</Column>
						<Column header="Company" field="company_name" style="min-width: 25%;" />
						<Column header="To" style="min-width: 25%;">
							<template #body="{ data }">
								<div class="spe-v2-email-mapping-email-list">
									<Chip v-for="email in data.email_to || []" :key="`${data.row_key}-to-${email}`" :label="email" class="mr-2 mb-2" />
								</div>
							</template>
						</Column>
						<Column header="CC" style="min-width: 25%;">
							<template #body="{ data }">
								<div class="spe-v2-email-mapping-email-list">
									<Chip v-for="email in data.email_cc || []" :key="`${data.row_key}-cc-${email}`" :label="email" class="mr-2 mb-2 spe-v2-email-mapping-chip--cc" />
								</div>
							</template>
						</Column>
						<Column header="Portal" style="min-width: 20%;">
							<template #body="{ data }">
								<Chip :label="Number(data.has_portal_user) ? 'Has Portal User' : 'Manual Mapping'" :class="Number(data.has_portal_user) ? 'spe-v2-email-mapping-chip--portal' : 'spe-v2-email-mapping-chip--manual'" />
							</template>
						</Column>
						<Column header="Type" style="min-width: 15%;">
							<template #body="{ data }">
								<Chip
									:label="data.supplier_type === 'FOREIGN' ? 'Foreign' : 'Local'"
									:class="data.supplier_type === 'FOREIGN' ? 'spe-v2-email-mapping-chip--foreign' : 'spe-v2-email-mapping-chip--local'"
								/>
							</template>
						</Column>
						<Column header="Updated" style="min-width: 25%;">
							<template #body="{ data }">
								{{ formatDateTime(new Date(data.updated_at)) }}
							</template>
						</Column>
						<Column header="Actions" frozen alignFrozen="right" style="min-width: 15%;">
							<template #body="{ data }">
								<Button icon="pi pi-pencil" label="Edit" class="p-button-sm" :disabled="!isPurchasingUser" @click="openEditDialog(data)" />
							</template>
						</Column>
					</DataTable>
				</div>
			</div>
		</div>

		<Dialog
			v-model:visible="showDialog"
			:header="dialogMode === 'add' ? 'Add Supplier Mapping' : 'Edit Supplier Mapping'"
			:modal="true"
			appendTo="body"
			:style="{ width: '48rem', maxWidth: '96vw' }"
			:draggable="false"
			:resizable="false"
			class="spe-v2-email-mapping-dialog"
			:baseZIndex="2000"
			@show="syncMappingDialogLayer"
			@hide="resetForm"
		>
			<div class="p-fluid">
				<div class="field mb-3">
					<label class="block mb-2 font-medium">Nama Supplier</label>
					<AutoComplete
						v-model="selectedSupplierOption"
						:suggestions="filteredSupplierOptions"
						field="label"
						:dropdown="true"
						:forceSelection="true"
						:loading="loadingOptions"
						:disabled="dialogMode === 'edit' || saving"
						placeholder="Pilih supplier"
						appendTo="body"
						panelClass="spe-v2-email-mapping-dialog-ac-panel"
						:baseZIndex="2200"
						:autoZIndex="true"
						@complete="searchSupplierOptions"
						@dropdown-click="onSupplierDropdown"
						@item-select="onSupplierSelected"
					/>
				</div>
				<div class="field mb-3">
					<label class="block mb-2 font-medium">Company</label>
					<InputText :modelValue="form.company_name" disabled />
				</div>
				<div class="field mb-3">
					<label class="block mb-2 font-medium">Supplier Type</label>
					<SelectButton
						v-model="form.supplier_type"
						:options="supplierTypeOptions"
						optionLabel="label"
						optionValue="value"
						:allowEmpty="false"
						:disabled="saving"
					/>
					<small class="text-500">Local = Indonesia template · Foreign = English template</small>
				</div>
				<div class="field mb-3">
					<label class="block mb-2 font-medium">To</label>
					<Chips v-model="form.email_to" separator=","
						:addOnBlur="true"
						placeholder="Masukkan satu atau lebih email To" />
				</div>
				<div class="field mb-3">
					<label class="block mb-2 font-medium">CC</label>
					<Chips v-model="form.email_cc" separator=","
						:addOnBlur="true"
						placeholder="Masukkan satu atau lebih email CC" />
				</div>
			</div>
			<template #footer>
				<Button label="Cancel" icon="pi pi-times" class="p-button-outlined mr-2" :disabled="saving" @click="showDialog = false" />
				<Button :label="saving ? 'Saving...' : 'Save'" icon="pi pi-save" class="p-button-success" :disabled="saving || !selectedSupplierOption" @click="saveMapping" />
			</template>
		</Dialog>
	</div>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useToast } from 'primevue/usetoast';
import SimpleCrypto from 'simple-crypto-js';
import AuthService from '../../service/AuthService';
import LovService from '../../service/LovService';
import SpeV2Service from '../../service/SpeV2Service';
import { formatDateTime } from '../../helper/formatDate';

const router = useRouter();
const toast = useToast();

/** Keep AutoComplete panels above DataTable frozen Actions (sticky stacking). */
const EMAIL_MAPPING_OVERLAY_Z_INDEX = 1100;

const breadcrumbHome = ref({ icon: 'pi pi-home', to: '/dashboard' });
const breadcrumbItems = ref([{ label: 'SPE Report', to: '/spe-v2' }, { label: 'Email Mapping', to: '/spe-v2/email-mapping' }]);

const currentUser = ref(null);
const company = ref(null);
const searchText = ref('');
const selectedSearchSupplier = ref(null);
const supplierLovOptions = ref([]);
const filteredSearchSupplierOptions = ref([]);
const loadingSearchOptions = ref(false);
const firstRow = ref(0);
const rowsPerPage = ref(10);
const totalRecords = ref(0);
const loadingMappings = ref(false);
const loadingOptions = ref(false);
const saving = ref(false);
const mappingRows = ref([]);
const supplierOptions = ref([]);
const filteredSupplierOptions = ref([]);
const showDialog = ref(false);
const dialogMode = ref('add');
const selectedSupplierOption = ref(null);

const form = reactive({
	vendor_id: '',
	supplier_name: '',
	org_id: '',
	db_instance: '',
	company_name: '',
	supplier_type: 'LOCAL',
	email_to: [],
	email_cc: [],
});

const supplierTypeOptions = [
	{ label: 'Local (Indonesia)', value: 'LOCAL' },
	{ label: 'Foreign (English)', value: 'FOREIGN' },
];

const isPurchasingUser = computed(() => currentUser.value && (currentUser.value.leveltenant == 1 || currentUser.value.leveltenant == 3 || currentUser.value.userid === 'dexaadmin'));

const normalizeEmailItems = (items) => {
	const seen = new Set();
	return (Array.isArray(items) ? items : [items])
		.flatMap((item) => String(item || '').split(/[,\n;]+/))
		.map((item) => item.trim())
		.filter((item) => item)
		.filter((item) => {
			const key = item.toLowerCase();
			if (seen.has(key)) return false;
			seen.add(key);
			return true;
		});
};

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());

const syncMappingDialogLayer = () => {
	requestAnimationFrame(() => {
		const dialog = document.querySelector('.spe-v2-email-mapping-dialog');
		if (!dialog) return;
		dialog.style.setProperty('z-index', '2000', 'important');
		const mask = dialog.closest('.p-dialog-mask') || document.querySelector('.p-dialog-mask');
		if (mask) {
			mask.style.setProperty('z-index', '1999', 'important');
		}
	});
};

const buildParams = (page = 1) => ({
	org_id: company.value?.value || company.value?.org_id || null,
	db_instance: company.value?.db_instance || null,
	page,
	limit: rowsPerPage.value,
	search: searchText.value.trim() || null,
});

const resetForm = () => {
	form.vendor_id = '';
	form.supplier_name = '';
	form.org_id = company.value?.value || company.value?.org_id || '';
	form.db_instance = company.value?.db_instance || '';
	form.company_name = company.value?.name || company.value?.company_name || '';
	form.supplier_type = 'LOCAL';
	form.email_to = [];
	form.email_cc = [];
	selectedSupplierOption.value = null;
};

const applySelectedSupplier = (option) => {
	if (!option) return;
	form.vendor_id = String(option.vendor_id || '');
	form.supplier_name = option.supplier_name || '';
	form.org_id = option.org_id || company.value?.value || company.value?.org_id || '';
	form.db_instance = option.db_instance || company.value?.db_instance || '';
	form.company_name = option.company_name || company.value?.name || '';
	form.supplier_type = option.supplier_type === 'FOREIGN' ? 'FOREIGN' : form.supplier_type || 'LOCAL';
	form.email_to = normalizeEmailItems(option.email_to || []);
	form.email_cc = normalizeEmailItems(option.email_cc || []);
};

const loadMappings = async (resetPage = false) => {
	if (!company.value?.value || !company.value?.db_instance) {
		mappingRows.value = [];
		totalRecords.value = 0;
		return;
	}

	if (resetPage) {
		firstRow.value = 0;
	}

	loadingMappings.value = true;
	try {
		const page = Math.floor(firstRow.value / rowsPerPage.value) + 1;
		const res = await SpeV2Service.getEmailMapping(buildParams(page));
		if (res.status === 200) {
			mappingRows.value = res.data.data || [];
			totalRecords.value = res.data.count || 0;
		} else {
			mappingRows.value = [];
			totalRecords.value = 0;
		}
	} catch (err) {
		console.log(err);
		toast.add({ severity: 'error', summary: 'Failed to load email mapping', life: 3000 });
	} finally {
		loadingMappings.value = false;
	}
};

const loadSearchSupplierLov = async (event) => {
	if (!company.value?.value || !company.value?.db_instance) {
		supplierLovOptions.value = [];
		filteredSearchSupplierOptions.value = [];
		return;
	}

	loadingSearchOptions.value = true;
	try {
		const res = await SpeV2Service.getEmailMappingSearchOptions({
			org_id: company.value.value || company.value.org_id,
			db_instance: company.value.db_instance,
			search: String(event?.query || '').trim() || null,
		});

		if (res.status === 200) {
			const rows = Array.isArray(res.data.data) ? res.data.data : [];
			supplierLovOptions.value = [...rows];
			filteredSearchSupplierOptions.value = [...rows];
		}
	} catch (err) {
		console.log(err);
		toast.add({ severity: 'error', summary: 'Failed to load supplier search options', life: 3000 });
	} finally {
		loadingSearchOptions.value = false;
	}
};

const searchSupplierLov = async (event) => {
	const keyword = String(event.query || '').trim();
	if (!keyword) {
		filteredSearchSupplierOptions.value = [...supplierLovOptions.value];
		return;
	}

	await loadSearchSupplierLov(event);
};

const onSearchSupplierSelected = async (event) => {
	const option = event.value;
	selectedSearchSupplier.value = option;
	searchText.value = option?.supplier_name || '';
	await loadMappings(true);
};

const clearSearchSupplier = async () => {
	selectedSearchSupplier.value = null;
	searchText.value = '';
	await loadMappings(true);
};

const loadSupplierOptions = async (search = '') => {
	if (!company.value?.value || !company.value?.db_instance) {
		supplierOptions.value = [];
		filteredSupplierOptions.value = [];
		return;
	}

	loadingOptions.value = true;
	try {
		const res = await SpeV2Service.getEmailMappingOptions({
			org_id: company.value.value || company.value.org_id,
			db_instance: company.value.db_instance,
			search: search || null,
		});
		if (res.status === 200) {
			const rows = Array.isArray(res.data.data) ? res.data.data : [];
			supplierOptions.value = [...rows];
			filteredSupplierOptions.value = [...rows];
		}
	} catch (err) {
		console.log(err);
		toast.add({ severity: 'error', summary: 'Failed to load supplier options', life: 3000 });
	} finally {
		loadingOptions.value = false;
	}
};

const refreshPage = async () => {
	await Promise.all([loadMappings(true), loadSupplierOptions(), loadSearchSupplierLov({ query: '' })]);
};

const searchSupplierOptions = async (event) => {
	const keyword = String(event.query || '').trim();
	if (!keyword) {
		filteredSupplierOptions.value = [...supplierOptions.value];
		return;
	}

	await loadSupplierOptions(keyword);
};

const onSupplierDropdown = async () => {
	if (!supplierOptions.value.length) {
		await loadSupplierOptions();
		filteredSupplierOptions.value = [...supplierOptions.value];
		return;
	}

	filteredSupplierOptions.value = [...supplierOptions.value];
};

const onSupplierSelected = (event) => {
	applySelectedSupplier(event.value);
};

const openAddDialog = async () => {
	resetForm();
	dialogMode.value = 'add';
	showDialog.value = true;
	await loadSupplierOptions();
	filteredSupplierOptions.value = [...supplierOptions.value];
};

const openEditDialog = async (row) => {
	dialogMode.value = 'edit';
	showDialog.value = true;
	await loadSupplierOptions();
	filteredSupplierOptions.value = [...supplierOptions.value];

	// Always use mapping row emails — LOV options have no email_to/email_cc
	const emailTo = Array.isArray(row.email_to) ? [...row.email_to] : normalizeEmailItems(row.email_to);
	const emailCc = Array.isArray(row.email_cc) ? [...row.email_cc] : normalizeEmailItems(row.email_cc);

	const matched = supplierOptions.value.find(
		(option) => String(option.vendor_id) === String(row.vendor_id) && option.company_name === row.company_name
	);

	selectedSupplierOption.value = {
		...(matched || {}),
		vendor_id: row.vendor_id,
		supplier_name: row.supplier_name,
		org_id: row.org_id,
		db_instance: row.db_instance,
		company_name: row.company_name,
		supplier_type: row.supplier_type || 'LOCAL',
		email_to: emailTo,
		email_cc: emailCc,
		label: row.supplier_name || String(row.vendor_id),
	};

	applySelectedSupplier(selectedSupplierOption.value);
	form.supplier_type = row.supplier_type === 'FOREIGN' ? 'FOREIGN' : 'LOCAL';
	form.email_to = normalizeEmailItems(emailTo);
	form.email_cc = normalizeEmailItems(emailCc);
};

const saveMapping = async () => {
	form.email_to = normalizeEmailItems(form.email_to);
	form.email_cc = normalizeEmailItems(form.email_cc);

	if (!selectedSupplierOption.value || !form.vendor_id || !form.company_name || !form.org_id || !form.db_instance) {
		toast.add({ severity: 'warn', summary: 'Supplier wajib dipilih', life: 3000 });
		return;
	}

	if (!form.email_to.length || !form.email_cc.length) {
		toast.add({ severity: 'warn', summary: 'Email To dan CC wajib diisi', life: 3000 });
		return;
	}

	if (!form.email_to.every(isValidEmail) || !form.email_cc.every(isValidEmail)) {
		toast.add({ severity: 'warn', summary: 'Format email tidak valid', life: 3000 });
		return;
	}

	saving.value = true;
	try {
		const res = await SpeV2Service.saveEmailMapping({
			vendor_id: form.vendor_id,
			supplier_name: form.supplier_name,
			org_id: form.org_id,
			db_instance: form.db_instance,
			company_name: form.company_name,
			supplier_type: form.supplier_type || 'LOCAL',
			email_to: form.email_to,
			email_cc: form.email_cc,
		});

		if (res.status === 200) {
			toast.add({ severity: 'success', summary: 'Mapping saved', life: 2500 });
			showDialog.value = false;
			await refreshPage();
		}
	} catch (err) {
		console.log(err);
		toast.add({
			severity: 'error',
			summary: err?.response?.data?.message || 'Failed to save mapping',
			life: 3000,
		});
	} finally {
		saving.value = false;
	}
};

const onPage = async (event) => {
	firstRow.value = event.first;
	rowsPerPage.value = event.rows;
	await loadMappings(false);
};

const resolveContext = async () => {
	const authRes = await AuthService.whoAmi();
	currentUser.value = authRes.data.data;

	if (!isPurchasingUser.value) {
		router.push('/dashboard');
		return;
	}

	const secretKey = 'some-unique-key';
	const simpleCrypto = new SimpleCrypto(secretKey);
	const decryptedCompany = simpleCrypto.decrypt(sessionStorage.getItem('dropdownCompany'));
	const companyRes = await LovService.getCompanyByName(decryptedCompany);

	if (companyRes.status === 200 && companyRes.data.data?.length) {
		company.value = companyRes.data.data[0];
	}

	resetForm();
	await refreshPage();
};

watch(
	() => company.value?.db_instance,
	() => {
		if (company.value?.db_instance) {
			resetForm();
		}
	}
);

onMounted(async () => {
	try {
		await resolveContext();
	} catch (err) {
		console.log(err);
		toast.add({ severity: 'error', summary: 'Failed to initialize page', life: 3000 });
	}
});
</script>

<style scoped>
.spe-v2-email-mapping-page {
	row-gap: 1rem;
}

.spe-v2-email-mapping-toolbar {
	position: relative;
	z-index: 2;
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 1rem;
	margin-bottom: 1rem;
}

.spe-v2-email-mapping-title {
	font-size: 1.125rem;
	font-weight: 600;
	color: #0f172a;
}

.spe-v2-email-mapping-subtitle {
	margin-top: 0.25rem;
	color: #64748b;
	font-size: 0.925rem;
}

.spe-v2-email-mapping-email-list {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
}

.spe-v2-email-mapping-search {
	min-width: 22rem;
}

.spe-v2-email-mapping-search-option {
	display: flex;
	flex-direction: column;
	gap: 0.125rem;
}

.spe-v2-email-mapping-chip--cc {
	background: #eef2ff;
	color: #3730a3;
}

.spe-v2-email-mapping-chip--manual {
	background: #fff7ed;
	color: #9a3412;
}

.spe-v2-email-mapping-chip--portal {
	background: #ecfdf5;
	color: #166534;
}

.spe-v2-email-mapping-chip--local {
	background: #eff6ff;
	color: #1d4ed8;
}

.spe-v2-email-mapping-chip--foreign {
	background: #f5f3ff;
	color: #6d28d9;
}

@media (max-width: 960px) {
	.spe-v2-email-mapping-toolbar {
		flex-direction: column;
		align-items: stretch;
	}
}
</style>

<style>
/*
 * Confine frozen-column sticky z-index inside the table stacking context.
 * Without isolation, Actions (sticky) paints above body-appended AutoComplete panels.
 */
.spe-v2-email-mapping-table {
	position: relative;
	z-index: 0;
	isolation: isolate;
}

/* Frozen Actions: header above body cells, still below LOV/modal overlays */
.spe-v2-email-mapping-table.p-datatable-scrollable .p-datatable-thead > tr > th {
	position: sticky;
	top: 0;
	z-index: 2;
	background: #ffecec !important;
}

.spe-v2-email-mapping-table.p-datatable-scrollable td.p-frozen-column {
	position: sticky !important;
	background: #fff !important;
	z-index: 1 !important;
	box-shadow: -6px 0 8px -4px rgba(0, 0, 0, 0.1);
}

.spe-v2-email-mapping-table.p-datatable-scrollable th.p-frozen-column {
	position: sticky !important;
	top: 0;
	background: #ffecec !important;
	z-index: 2 !important;
	box-shadow: -6px 0 8px -4px rgba(0, 0, 0, 0.1);
}

/* Saat modal terbuka, sticky/frozen jangan menembus dialog */
body.p-overflow-hidden .spe-v2-email-mapping-table.p-datatable-scrollable .p-datatable-thead > tr > th,
body.p-overflow-hidden .spe-v2-email-mapping-table.p-datatable-scrollable th.p-frozen-column,
body.p-overflow-hidden .spe-v2-email-mapping-table.p-datatable-scrollable td.p-frozen-column {
	position: relative !important;
	top: auto !important;
	z-index: 0 !important;
	box-shadow: none !important;
}

.spe-v2-email-mapping-dialog.p-dialog {
	z-index: 2000 !important;
}

/* Body-appended search LOV must sit above the isolated table layer */
.spe-v2-email-mapping-ac-panel.p-autocomplete-panel {
	z-index: 1100 !important;
}

/* Dialog LOV must sit above the mapping modal (z-index 2000) */
.spe-v2-email-mapping-dialog-ac-panel.p-autocomplete-panel {
	z-index: 2200 !important;
}
</style>
